var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c("b-col", {
                    staticClass: "my-1",
                    attrs: { cols: "12", md: "2", sm: "1" },
                  }),
                  _c("b-col", {
                    staticClass: "d-flex justify-content-end mb-2",
                    staticStyle: { position: "relative", "z-index": "1" },
                    attrs: { cols: "12" },
                  }),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredEmployees,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm.HasPermission(
                                      _vm.PermissionList.HRMS_View
                                    )
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: {
                                              to: {
                                                name: "payroll-view",
                                                params: {
                                                  id: data.item.id,
                                                  allocationDate:
                                                    data.item.formattedDate,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "EyeIcon" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "align-middle ml-50",
                                              },
                                              [_vm._v("View")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }